import { Dispatch, createContext } from "react";

export interface ICRMPermissionContext {
  permissions: string[];
  crmRoles: string[];
  setCampaignSlug?: Dispatch<string>;
  allowedContactSources: string[];
}

const defaultValues: ICRMPermissionContext = {
  permissions: [],
  crmRoles: [],
  allowedContactSources: [],
  setCampaignSlug: undefined,
};

export const CRMPermissionContext =
  createContext<ICRMPermissionContext>(defaultValues);
